import React, { useState } from "react";
import { Col, Container, Row, Accordion } from "react-bootstrap";
import Ecommerce from "../../images/services/cto/Ecommerce.svg";
import RealEstate from "../../images/services/cto/RealEstate.svg";
import Gaming from "../../images/services/cto/Gaming.svg";
import Healthcare from "../../images/services/cto/Healthcare.svg";
import Lifestyle from "../../images/services/cto/lifestyle.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Industries(props) {
  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const getActiveClass = (index, className) =>
    toggleState === index ? className : "";

  return (
    <div className="seriveces_industries p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={7}>
            <div className="example" data-text="We Serve">
              <h2>Industries We Serve</h2>
            </div>
            <p className="strong">
              We create and deploy essential to high-magnitude software programs
              and computing solutions for diverse industries in the business
              ecosystem.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="deskstop_version"
          >
            <div className="process_icons">
              <ul>
                <li
                  className={`tabs ${getActiveClass(1, "active-tabs")}`}
                  onClick={() => toggleTab(1)}
                >
                  <div className="iconss">
                    <LazyLoadImage
                      src={Healthcare}
                      effect="blur"
                      alt="Healthcare"
                      className="img-fluid"
                    />
                  </div>
                  Healthcare
                </li>
                <li
                  className={`tabs ${getActiveClass(2, "active-tabs")}`}
                  onClick={() => toggleTab(2)}
                >
                  <div className="iconss">
                    <LazyLoadImage
                      src={RealEstate}
                      effect="blur"
                      alt="Real Estate"
                      className="img-fluid"
                    />
                  </div>
                  Real Estate
                </li>

                <li
                  className={`tabs ${getActiveClass(3, "active-tabs")}`}
                  onClick={() => toggleTab(3)}
                >
                  <div className="iconss">
                    <LazyLoadImage
                      src={Gaming}
                      effect="blur"
                      alt="Gaming"
                      className="img-fluid"
                    />
                  </div>
                  Gaming
                </li>
                <li
                  className={`tabs ${getActiveClass(4, "active-tabs")}`}
                  onClick={() => toggleTab(4)}
                >
                  <div className="iconss">
                    <LazyLoadImage
                      src={Ecommerce}
                      effect="blur"
                      alt="Ecommerce"
                      className="img-fluid"
                    />
                  </div>
                  Ecommerce
                </li>
                <li
                  className={`tabs ${getActiveClass(5, "active-tabs")}`}
                  onClick={() => toggleTab(5)}
                >
                  <div className="iconss">
                    <LazyLoadImage
                      src={Lifestyle}
                      effect="blur"
                      alt="Lifestyle"
                      className="img-fluid"
                    />
                  </div>
                  Lifestyle
                </li>
              </ul>

              <div
                className={
                  toggleState === 1 ? "content d-block" : "content d-none"
                }
              >
                <p>
                  TekRevol comprehensively caters to the requirements of the
                  healthcare and wellness industry, building technically sound,
                  experience-focused, and user-centric digital solutions. Our
                  <Link to="https://www.tekrevol.com/healthcare-app-development">
                    healthcare app development
                  </Link>{" "}
                  team understands the dynamics of working in this industry and
                  blending it with digital commerce for health-related physical
                  and tech accessories.
                </p>
              </div>
              <div
                className={
                  toggleState === 2 ? "content d-block" : "content d-none"
                }
              >
                <p>
                  The real estate industry challenges are different, requiring a
                  totally unique course of action. Our projects like Estate Pie
                  speak volumes about TekRevol’s holistic, agile development
                  approach, utilizing which we develop technology solutions that
                  are not packed with mere features but deliver actual value to
                  the end-users and help achieve the business objectives.
                </p>
              </div>
              <div
                className={
                  toggleState === 3 ? "content d-block" : "content d-none"
                }
              >
                <p>
                  The gaming industry is among the most profitable industries
                  around the globe, but not everyone can build a perfect game.
                  At TekRevol, our expert team of software engineers and
                  developers create games following industry standards:
                  cross-platform to cloud functionality, stunning graphics, and
                  fluid player experience. Our games, gaming platforms, and
                  solutions are turnkey products with high monetization
                  potential.
                </p>
              </div>
              <div
                className={
                  toggleState === 4 ? "content d-block" : "content d-none"
                }
              >
                <p>
                  Ecommerce markets are booming worldwide, helping the masses
                  reap benefits with much effort. Now you can increase
                  conversion rates through digitalizing, with or without
                  brick-and-mortar businesses. We at TekRevol, build ecommerce
                  solutions that function seamlessly for you and the end-users
                  and help you gain unlimited advantages of digitalization, from
                  quality lead gen to the consumer experience.
                </p>
              </div>
              <div
                className={
                  toggleState === 5 ? "content d-block" : "content d-none"
                }
              >
                <p>
                  A vast market worldwide uses various lifestyle digital
                  products, from web apps to smartwatch widgets to desktop
                  programs. These digital solutions provide helpful content,
                  information, and products to the users and present immense
                  potential for making money through multiple monetization
                  models. TekRevol can build the right lifestyle solution for
                  you.
                </p>
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mobile_version"
          >
            <div className="tekrevol_mobile_accordion_side">
              <Accordion defaultActiveKey="1">
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    <LazyLoadImage
                      src={Healthcare}
                      effect="blur"
                      alt="Healthcare"
                      className="img-fluid"
                    />
                    Healthcare
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      TekRevol comprehensively caters to the requirements of the
                      healthcare and wellness industry, building technically
                      sound, experience-focused, and user-centric digital
                      solutions. Our{" "}
                      <Link to="https://www.tekrevol.com/healthcare-app-development">
                        healthcare app development
                      </Link>{" "}
                      team understands the dynamics of working in this industry
                      and blending it with digital commerce for health-related
                      physical and tech accessories.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    <LazyLoadImage
                      src={RealEstate}
                      effect="blur"
                      alt="Real Estate"
                      className="img-fluid"
                    />
                    Real Estate
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      The real estate industry challenges are different,
                      requiring a totally unique course of action. Our projects
                      like Estate Pie speak volumes about TekRevol’s holistic,
                      agile development approach, utilizing which we develop
                      technology solutions that are not packed with mere
                      features but deliver actual value to the end-users and
                      help achieve the business objectives.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    <LazyLoadImage
                      src={Gaming}
                      effect="blur"
                      alt="Gaming"
                      className="img-fluid"
                    />
                    Gaming
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      The gaming industry is among the most profitable
                      industries around the globe, but not everyone can build a
                      perfect game. At TekRevol, our expert team of software
                      engineers and developers create games following industry
                      standards: cross-platform to cloud functionality, stunning
                      graphics, and fluid player experience. Our games, gaming
                      platforms, and solutions are turnkey products with high
                      monetization potential.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    <LazyLoadImage
                      src={Ecommerce}
                      effect="blur"
                      alt="Ecommerce"
                      className="img-fluid"
                    />
                    Ecommerce
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Ecommerce markets are booming worldwide, helping the
                      masses reap benefits with much effort. Now you can
                      increase conversion rates through digitalizing, with or
                      without brick-and-mortar businesses. We at TekRevol, build
                      ecommerce solutions that function seamlessly for you and
                      the end-users and help you gain unlimited advantages of
                      digitalization, from quality lead gen to the consumer
                      experience.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>
                    <LazyLoadImage
                      src={Lifestyle}
                      effect="blur"
                      alt="Lifestyle"
                      className="img-fluid"
                    />
                    Lifestyle
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      A vast market worldwide uses various lifestyle digital
                      products, from web apps to smartwatch widgets to desktop
                      programs. These digital solutions provide helpful content,
                      information, and products to the users and present immense
                      potential for making money through multiple monetization
                      models. TekRevol can build the right lifestyle solution
                      for you.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Industries;
